<template>
  <div ref="popover" class="label-popover-wrapper">
    <span
        @click="togglePopover"
        class="label-button relative"
        :class="{ active: popoverVisible }"
        title="Gerenciar marcadores"
    >
      <bookmark-icon size="1x" class="mb-1" />
    </span>

    <div v-if="popoverVisible" class="label-popover" :style="popoverPosition">
      <button @click="toggleCreation" class="btn btn-link float-right">
        {{ enableCreation ? 'Cancelar' : 'Criar novo marcador' }}
      </button>

      <div v-show="!enableCreation">
        <h5 class="mt-2 mb-3">Marcadores</h5>

        <!-- Search -->
        <div class="mt-2">
          <div v-if="labels.length">
            <p class="mt-3">Selecione os marcadores que deseja vincular:</p>
            <input v-model="generic" class="input form-control mb-3" placeholder="Pesquisar marcador">
          </div>
          <div v-else>
            <p class="mt-3">Nenhum marcador encontrado.</p>
          </div>
        </div>

        <!-- Show Labels -->
        <div class="table-container">
          <table class="table">
            <tbody>
              <tr v-for="(label, index) in showLabels" :key="index">
                <td>
                  <input
                      type="checkbox"
                      v-model="label.enabled"
                      :value="label"
                      :id="'labelCheckbox_' + index"
                  >
                </td>
                <td>
                  {{ label.name }}
                </td>
                <td>
                  <button @click="deleteLabel(label)" class="btn-icon btn-outline-red ml-2 mr-3 float-right">
                    <trash-2-icon size="1.5x"/>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <hr>

        <div class="text-center">
          <button @click="associateLabels" class="btn btn-primary btn-block">Salvar</button>
          <button @click="togglePopover" class="btn btn-link">Fechar</button>
        </div>
      </div>

      <!-- Create Label -->
      <div v-show="enableCreation">
        <h5 class="mt-2 mb-3">Novo marcador</h5>
        <div class="mb-3">
          <label for="label-name">Escolha um nome:</label>
          <input id="label-name" v-model="newLabel.name" type="text" class="form-control" placeholder="Ex: C-137, Pago, Em atraso">
        </div>
        <div class="mb-3">
          <div class="form-group">
            <label for="label-color">Selecione uma cor:</label>
            <div style="display: flex; flex-wrap: wrap; gap: 6px;">
              <button
                  v-for="color in colorOptions"
                  @click="selectColor(color)"
                  :key="color.value"
                  :title="color.label"
                  class="btn btn-sm p-0"
                  :style="{
                    backgroundColor: `#${color.value}`,
                    width: '26px',
                    height: '26px',
                    outline: newLabel.kind === color.kind ? '2px solid #051B30' : 'none',
                    outlineOffset: '1px'
                  }"
              >
              </button>
            </div>
          </div>
        </div>
        <div>
          <button
            :disabled="disabledCreateButton || nonWhiteSpace"
            class="btn btn-primary btn-block"
            @click="createLabel"
          >
            Criar marcador
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const labelPath = '/maestro/labels'

import { Trash2Icon, BookmarkIcon } from 'vue-feather-icons'
export default {
  name: 'LabelPopover',
  components: {
    Trash2Icon,
    BookmarkIcon,
  },
  props: {
    triggerText: String,
    labels: Array,
    labelIds: Array,
    linkedTickets: [],
  },
  data: () => ({
    generic: '',
    popoverVisible: false,
    newLabel: {},
    cloneLabels: [],
    enableCreation: false,
    popoverPosition: {},
  }),
  computed: {
    colorOptions() {
      return [
        { label: 'Verde', value: '15ce9a', kind: 'success' },
        { label: 'Vermelho', value: 'e93f66', kind: 'danger' },
        { label: 'Amarelo', value: 'f4d03f', kind: 'warning' },
        { label: 'Azul', value: '318be3', kind: 'info' },
        { label: 'Cinza', value: '87929c', kind: 'default' },
        { label: 'Roxo', value: '8b5cf6', kind: 'purple' },
        { label: 'Laranja', value: 'f97316', kind: 'orange' },
        { label: 'Verde-água', value: '14b8a6', kind: 'teal' },
        { label: 'Rosa', value: 'ec4899', kind: 'pink' },
        { label: 'Índigo', value: '6366f1', kind: 'indigo' },
        { label: 'Lima', value: '65a30d', kind: 'lime' },
        { label: 'Ciano', value: '0891b2', kind: 'cyan' },
        { label: 'Vinho', value: 'e11d48', kind: 'rose' },
        { label: 'Âmbar', value: 'd97706', kind: 'amber' },
        { label: 'Ardósia', value: '475569', kind: 'slate' },
      ]
    },
    disabledCreateButton() {
      return !this.newLabel.name || !this.newLabel.kind
    },
    nonWhiteSpace() {
      return !this.newLabel.name || this.newLabel.name.trim() === '';
    },
    showLabels() {
      const filteredLabels = this.generic ?
          this.cloneLabels.filter(label => label.name.toLowerCase().includes(this.generic.toLowerCase())) :
          this.cloneLabels

      return filteredLabels.slice().sort((a, b) => {
        const nameA = a.name.toLowerCase()
        const nameB = b.name.toLowerCase()

        if (nameA < nameB)
          return -1
        if (nameA > nameB)
          return 1
        return 0;
      })
    }
  },
  methods: {
    associateLabels() {
      this.$emit('associateLabels', this.cloneLabels.filter(label => label.enabled).map(label => label.id))
      this.closePopover()
    },
    selectColor(color) {
      this.$set(this.newLabel, 'kind',  color.kind)
    },
    setCloneLabels() {
      this.cloneLabels = this.labels.map(label => ({
        ...label,
        enabled: this.labelIds.includes(label.id)
      }))

      this.cloneLabels.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
    togglePopover() {
      this.popoverVisible = !this.popoverVisible
      if (this.popoverVisible) {
        this.setCloneLabels()
        this.enableCreation = false
        this.$nextTick(() => {
          this.updatePosition()
          document.addEventListener('click', this.handleClickOutside)
        })
      }
    },
    updatePosition() {
      const rect = this.$refs.popover.getBoundingClientRect()
      const popoverHeight = 470
      let top = rect.bottom + 5
      const right = window.innerWidth - rect.right

      if (top + popoverHeight > window.innerHeight) {
        top = rect.top - popoverHeight - 5
      }

      if (top < 10) {
        top = 10
      }

      this.popoverPosition = {
        top: top + 'px',
        right: right + 'px',
      }
    },
    closePopover() {
      this.popoverVisible = false
      this.cleanData()
      document.removeEventListener('click', this.handleClickOutside)
    },
    cleanData() {
      this.enableCreation = false
      this.newLabel = {}
      this.generic = ''
    },
    createLabel() {
      this.axios.post(labelPath, { ...this.newLabel, app_name: 'cm-frotas' })
        .then(response => response.data)
        .then(label => this.labels.push(label))
        .then(() => this.$emit('changeLabels'))
        .then(() => this.cleanData())
        .then(() => this.setCloneLabels())
        .catch(e => this.$notify.addError(e))
    },
    handleClickOutside(event) {
      if (this.$refs.popover && !this.$refs.popover.contains(event.target)) {
        this.closePopover()
      }
    },
    toggleCreation() {
      this.enableCreation = !this.enableCreation
    },
    fetchLabelsLinkedToTicket(labelId, callback) {
      this.axios.get(`${labelPath}/${labelId}`)
        .then(response => response.data)
        .then(data => callback(data.count_tickets))
        .catch(e => this.$notify.addError(e))
    },
    deleteLabel(label) {
      const deleteLabelMessage = total => `Atenção! \n\nExiste(m) ${total} multa(s) vinculada(s) ao marcador ${label.name.toUpperCase()}. \n\nTodas as multas serão desvinculadas deste marcador. Deseja continuar?`

      this.fetchLabelsLinkedToTicket(label.id, (total) => {
        if (!confirm(deleteLabelMessage(total)))
          return

        this.axios.delete(`${labelPath}/${label.id}`)
          .then(() => this.$emit('deletedLabel'))
          .then(() => this.removeLabel(label))
          .catch(e => this.$notify.addError(e))
      })
    },
    removeLabel(label) {
      const index = this.labels.findIndex(l => l.id === label.id)
      this.labels.splice(index, 1)
      this.setCloneLabels()
      this.$emit('changeLabels')
    }
  }
}
</script>

<style scoped>
.label-popover {
  position: fixed;
  z-index: 1000;
  background-color: var(--white-bg);
  color: var(--primary-text-color);
  border: 1px solid var(--border-color);
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  padding: 10px;
  width: 400px;
  max-height: 470px;
  overflow-y: auto;
}

.label-popover h5,
.label-popover p,
.label-popover label {
  color: var(--primary-text-color);
}

.label-popover table {
  color: var(--primary-text-color);
}

.close-icon {
  position: absolute;
  top: 5px;
  right: 10px;
  cursor: pointer;
}

.existing-labels {
  margin-top: 15px;
}

.table-container {
  max-height: 200px;
  overflow-y: auto;
}

.label-button {
  cursor: pointer;
  padding: 2px 6px 2px 6px;
  background: grey;
  color: white;
  border-radius: 3px;
  font-size: 16px;
}

.label-button:hover {
  background: #ccc;
}

</style>
